module.exports = __webpack_public_path__ + "static/img/menu1.1132b99f.png";